import { useConnectToDiscordMutation } from '@/service/discord/discord.hook';
import {
  createFileRoute,
  Navigate,
  useRouter,
  useSearch,
} from '@tanstack/react-router';
import { enqueueSnackbar } from 'notistack';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ImSpinner8 } from 'react-icons/im';
import z from 'zod';

const discordCodeSchema = z.object({
  code: z.string().optional(),
});

export const Route = createFileRoute('/_dashboard/dashboard/discord/')({
  component: RouteComponent,
  validateSearch: (params) => discordCodeSchema.parse(params),
});

function RouteComponent() {
  const params = useSearch({ from: '/_dashboard/dashboard/discord/' });
  const router = useRouter();
  const { t } = useTranslation('settings');
  const connectToDiscord = useConnectToDiscordMutation({
    onSuccess() {
      enqueueSnackbar({
        variant: 'success',
        message: t('connected'),
      });
      router.navigate({
        to: '/dashboard/settings',
      });
    },
    onError() {
      enqueueSnackbar({
        variant: 'error',
        message: t('connectionErrorDiscord'),
      });
      router.navigate({
        to: '/dashboard/settings',
      });
    },
  });

  useEffect(() => {
    if (params.code) connectToDiscord.mutate(params.code);
  }, []);

  if (!params.code) return <Navigate to="/dashboard/settings" replace />;

  return (
    <div className="m-auto page-container">
      <div className="mt-16 flex justify-center items-center flex-col">
        <h2 className="text-xl">{t('connecting')}</h2>
        <ImSpinner8 className="animate-spin mt-8 size-8" />
      </div>
    </div>
  );
}
